module.exports = __webpack_public_path__ + "static/media/ic_calendar-error.99f0473d.svg";